import * as util from '../apiUtils';
import * as common from '../apiCommon';
import * as DocType from '../../constants/constant_doc_types';
import { saveEntity } from '../entity/api_entity';

export function fetchSupplierDropdown(app, params) {
  const { searchTerm, searchParams, fields, id } = params;
  const dropdown_type = 'entity/supplier/dropdown';

  const query = {
    id,
    dropdown_type,
    fields,
    searchTerm,
    searchParams
  };

  return common.getDropdownList(app, { query });
}

export async function fetchSupplierForEdit(app, params) {
  const { id, path } = params;
  const docType = DocType.ENTITY;
  const doc = await common.getDoc(app, { id, docType }, { assemble_custom_fields: true });

  return util.filterCustomFieldsByViewMode(doc, path);
}

export function deleteSupplier(app, params) {
  const { id } = params;
  return common.deleteDoc(app, {
    id: id,
    docType: DocType.ENTITY
  });
}

export function saveSupplier(app, dataToSave) {
  return saveEntity(app, dataToSave);
}
